define('order_wizard_promocodenotifications.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('order_wizard_promocodenotifications', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " \r\n";
},"useData":true}, 'extensions/SuiteDB/CCAW_Theme/2.4.35/', 'extensions/SuiteDB/CCAW_Theme/2.4.35/', Handlebars);
});